<template>
  <div class="ht-container ht-container-admin pb-5">
    <nav class="nav nav-pills mb-3 admin-nav-tertiary" role="tablist">
      <a href="#basic_settings" class="nav-link active">
        Basic Settings
      </a>
      <a href="#profile" class="nav-link">
        Profile
      </a>
      <a href="#terms" class="nav-link">
        Terms & Conditions
      </a>
    </nav>
    <div>
      <form class="admin-form">
        <div class="inner">
          <div class="form-group">
            <label for="home_name">Name of the Household</label>
            <input id="home_name" type="text" class="form-control" aria-describedby="home_name_help" placeholder="Elliott Residence">
            <small id="home_name_help" class="form-text text-muted">A household embodies everyone living at a property.</small>
          </div>
          <div class="form-group">
            <label for="home_name">Subdomain</label>
            <input id="home_name" type="text" class="form-control" aria-describedby="home_name_help" placeholder="elliott-home">
            <small id="home_name_help" class="form-text text-muted">Subdomains are used to uniquely identify your household on hometender.</small>
          </div>
          <div class="form-row mb-4">
            <div class="col">
              <label for="home_name">Address</label>
              <input id="home_name" type="text" class="form-control" aria-describedby="home_name_help" placeholder="123 Washington St">
            </div>
            <div class="col">
              <label for="home_name">City</label>
              <input id="home_name" type="text" class="form-control" aria-describedby="home_name_help" placeholder="San Francisco">
            </div>
            <div class="col">
              <label for="home_name">Postal Code</label>
              <input id="home_name" type="text" class="form-control" aria-describedby="home_name_help" placeholder="94123">
            </div>
          </div>
          <div class="form-row">
            <div class="col">
              <label for="home_name">Country</label>
              <select class="custom-select" id="inlineFormCustomSelectPref">
                <option selected>Choose...</option>
                <option value="CA">Canada</option>
                <option value="UK">United Kingdom</option>
                <option value="US">United States</option>
              </select>
            </div>
            <div class="col">
              <label for="home_name">Time Zone</label>
              <select class="custom-select" id="inlineFormCustomSelectPref">
                <option selected>Choose...</option>
                <option value="UTC-8">(UTC-8) America - Los Angeles</option>
              </select>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';

@Component
class BasicSetup extends Vue {

}
export default BasicSetup;
</script>

<style scoped>

</style>
